import React, { useState, useRef } from 'react';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import { Button, Col, Drawer, Form, Input, Row, Space, message, Switch, InputNumber, Select } from 'antd';
import { insertManual, updateManual, getById } from '../../../../apis/OdooLeaveTypeApi';
import CLASE_AUSENCIA_OPTIONS from '../../../../constants/claseAusencia';

const App = ({ title, id, open, finish }) => {
    const [form] = Form.useForm()
    const [ID, setID] = useState(id);
    const [initialValues, setInitialValues] = useState(null);
    const [disabled, setDisabled] = useState(false);

    const handleOk = async () => {
        try {
            const fields = await form.validateFields();
            let success = false;
            if (ID > 0) {
                //Update
                const payload = {
                    id: ID,
                    ...fields,
                }
                const response = await updateManual(payload);
                success = response.ok;
                if (response.ok) {
                    message.success('Se actualizó correctamente el tipo de permiso!');
                }
            } else {
                //Create
                const payload = {
                    ...fields,
                }
                const response = await insertManual(payload);
                success = response.ok;
                if (response.ok) {
                    setID(response.payload);
                    message.success('Se guardó correctamente el tipo de permiso!');
                }
            }

            if (success) {
                finish(true);
            }
        } catch (errorInfo) {
            message.error('Por favor completa todos los campos obligatorios.');
        }
    }

    const onClose = () => {
        finish(false);
        setInitialValues(null);
        form.resetFields();
    }

    const effectRan = useRef(false);
    React.useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                if (ID > 0) {
                    refreshData();
                } else {
                    setInitialValues({
                        name: '',
                        description: '',
                        max_leaves: 0.0,
                        active: true,
                        clase: null,
                    });
                }
            })();
        }
        return () => effectRan.current = true;
    }, [ID]);

    React.useEffect(() => {
        if (initialValues) {
            form.setFieldsValue(initialValues);
        }
    }, [form, initialValues]);

    const refreshData = async () => {
        const response = await getById(ID);
        if (response.ok) {
            let item = response.payload;
            setInitialValues(item);
        }
    }

    return (
        <Drawer
            title={<>
                {ID > 0 ? '(' + ID + ') ' : ''}
                {title}
            </>}
            placement={"right"}
            onClose={onClose}
            open={open}
            closable={true}
            height={'100%'}
            styles={{
                body: {
                    paddingBottom: 80,
                },
            }}
            extra={[
                <Space>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleOk} type="primary">
                        Guardar
                    </Button>
                </Space>
            ]}
        >
            {
                initialValues &&
                <Form layout="vertical" disabled={disabled}
                    form={form} requiredMark initialValues={initialValues} >
                    <Row gutter={16}>
                        <Col md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item
                                name="name"
                                label="Nombre"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Por favor agrega el nombre',
                                    },
                                ]}>
                                <Input placeholder="Nombre del tipo de permiso" style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>
                        <Col md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item
                                name="description"
                                label="Descripción"
                            >
                                <Input.TextArea placeholder="Descripción del tipo de permiso" style={{ width: '100%' }} rows={3} />
                            </Form.Item>
                        </Col>
                        <Col md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item
                                name="clase"
                                label="Clase"
                            >
                                <Select
                                    allowClear
                                    placeholder="Selecciona la clase"
                                    style={{ width: '100%' }}
                                    options={CLASE_AUSENCIA_OPTIONS.map(c => ({ value: c.value, label: c.text }))}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                            <Form.Item
                                name="max_leaves"
                                label="Máximo de Días"
                            >
                                <InputNumber 
                                    placeholder="0.00" 
                                    style={{ width: '100%' }} 
                                    min={0}
                                    step={0.5}
                                />
                            </Form.Item>
                        </Col>
                        <Col md={{ span: 12 }} sm={{ span: 12 }} xs={{ span: 24 }}>
                            <Form.Item
                                name="active"
                                label="Activo"
                                valuePropName="checked"
                            >
                                <Switch checkedChildren={<CheckOutlined />} unCheckedChildren={<CloseOutlined />} />
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            }
        </Drawer>
    );
};
export default App;